export default "__VITE_ASSET__zpvq7SBX__"